import React, { useEffect, useMemo, useState } from 'react';
import { Drawer, DrawerProps, Tooltip, Typography, Box, Paper, Button, useTheme, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { FilterInputs } from './FilterInputs';

interface FiltersDrawerInputsProps {
  id: string;
  type: 'erp-origem' | 'autocomplete' | 'text' | 'number' | 'date';
}

interface FiltersDrawerProps extends DrawerProps {
  drawerId: string;
  onApply?: () => void;
  onOpen?: () => void;
  onClose?: () => void;
  onClearFilter?: () => void;
  buttonClearFilter?: boolean;
  inputs?: FiltersDrawerInputsProps[];
  showDrawer?: boolean;
}

export default function FiltersDrawer(props: FiltersDrawerProps) {
  const {
    drawerId,
    children,
    onApply,
    onClose,
    onOpen,
    onClearFilter,
    showDrawer,
    buttonClearFilter = true,
    inputs = [],
  } = props;

  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [inputValues, setInputValues] = useState<Record<string, any>>({});

  useEffect(() => {
    setOpen(showDrawer);
  }, [showDrawer]);

  useEffect(() => {
    if (open) {
      onOpen?.();
    } else {
      onClose?.();
    }
  }, [open]);

  const handleInputChange = (id: string, value: any) => {
    setInputValues(prev => ({ ...prev, [id]: value }));
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Paper
        elevation={1}
        square
        sx={{
          minWidth: 364,
          maxWidth: '100vw',
          zIndex: 2,
        }}
      >
        <Box m={1} display="flex" alignItems="center">
          <Tooltip title="Fechar Filtro">
            <IconButton aria-label="close" color="warning" onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
          <Box flex={1} display="flex" justifyContent="center" alignItems="center">
            <Typography>Filtros</Typography>
          </Box>
          <Tooltip title="Limpar Filtro">
            <IconButton
              aria-label="clear"
              color="secondary"
              onClick={() => {
                setInputValues({});
              }}
            >
              <DeleteSweepIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </Paper>

      <Box pt={2} height="100%" flex={1}>
        {inputs?.map(input => (
          <FilterInputs
            key={input.id}
            id={input.id}
            type={input.type}
            value={inputValues[input.id] || ''}
            onChange={value => handleInputChange(input.id, value)}
          />
        ))}
        {children}
      </Box>

      <Box p={1}>
        <Tooltip title="Aplicar filtro">
          <Button fullWidth variant="outlined" color="success" onClick={onApply}>
            Aplicar Filtro
          </Button>
        </Tooltip>
      </Box>
    </Drawer>
  );
}
